<template>
    <div class="container">
        <b-modal
            :model-value="showModal"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            size="lg"
            :title="labels.titulo"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-account-dialog"
         @hide="cancelar">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Mensaje de error -->
                <div v-if="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
                    <span class="error-icon">!</span>
                    {{ errorMessage }}
                    <button type="button" class="close" @click="errorMessage = ''" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Campo Cuenta -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.cuenta }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="cuentaNueva.cuenta" 
                            type="text"
                            class="form-input"
                            :disabled="loading"
                            :placeholder="labels.cuentaPlaceholder"
                            required
                            @input="errorMessage = ''"
                        />
                    </b-col>
                </b-row>

                <!-- Campo Descripción -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.descripcion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="cuentaNueva.descripcion" 
                            type="text"
                            class="form-input"
                            :disabled="loading"
                            :placeholder="labels.descripcionPlaceholder"
                            required
                            @input="errorMessage = ''"
                        />
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button 
                        class="mr-2 reset-btn-secondary" 
                        @click="cancelar" 
                        :disabled="loading"
                    >
                        {{ labels.cancelar }}
                    </b-button>
                    <b-button 
                        class="reset-btn-primary" 
                        @click="guardarCuenta" 
                        :disabled="!formValido || loading"
                    >
                        <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                        {{ loading ? labels.guardando : labels.guardar }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import AjustesConsol from '../../services/AjustesConsol'

export default {
    name: 'CuentaNuevaDestino',
    props: {
        showModal: Boolean,
        idCompania: Number,
        codReporte: Number,
        vigencia: String,
        secuencia: Number,
        tipo_ajuste: Number,
        tipo: String
    },
    data() {
        return {
            cuentaNueva: {
                cuenta: '',
                descripcion: ''
            },
            loading: false,
            errorMessage: ''
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    titulo: 'Crear Cuenta Nueva - Destino',
                    cuenta: 'Número de Cuenta',
                    descripcion: 'Descripción',
                    cancelar: 'Cancelar',
                    guardar: 'Guardar',
                    guardando: 'Guardando...',
                    cuentaPlaceholder: 'Ej: 1234567890',
                    descripcionPlaceholder: 'Ej: Descripción de la cuenta',
                    infoTitle: 'Nueva cuenta destino',
                    infoText: 'Ingresa los datos de la nueva cuenta de destino y guarda los cambios.'
                }
            } else {
                return {
                    titulo: 'Create New Account - Destination',
                    cuenta: 'Account Number',
                    descripcion: 'Description',
                    cancelar: 'Cancel',
                    guardar: 'Save',
                    guardando: 'Saving...',
                    cuentaPlaceholder: 'Ex: 1234567890',
                    descripcionPlaceholder: 'Ex: Account description',
                    infoTitle: 'New destination account',
                    infoText: 'Enter the new destination account data and save the changes.'
                }
            }
        },
        formValido() {
            return this.cuentaNueva.cuenta && 
                   this.cuentaNueva.descripcion
        }
    },
    methods: {
        cancelar() {
            if (this.loading) return
            this.limpiarFormulario()
            this.$emit('closeModal', false)
        },

        limpiarFormulario() {
            this.cuentaNueva = {
                cuenta: '',
                descripcion: ''
            }
        },

        async guardarCuenta() {
            if (this.loading) return
            this.loading = true
            this.errorMessage = ''

            try {
                const datos = {
                    vigencia: this.vigencia,
                    companyId: this.idCompania,
                    idUser: this.$store.state.id_user || 1,
                    codReporte: this.codReporte,
                    tipo_ajuste: this.tipo_ajuste || 2,
                    secuencia: this.secuencia,
                    cuenta: this.cuentaNueva.cuenta,
                    descripcion: this.cuentaNueva.descripcion,
                    saldo_actual: 0,
                    id_compania: this.idCompania,
                    tipo: this.tipo,
                    origen_destino: 'D'
                }

                console.log('Datos para crear cuenta nueva DESTINO:', datos)

                await AjustesConsol.crearCuentaNuevaDestino(datos)
                
                this.$emit('cuentaCreada')
                this.limpiarFormulario()
                this.$emit('closeModal', true)
            } catch (error) {
                console.error('Error al crear cuenta destino:', error)
                this.errorMessage = error.response?.data?.message || 'Error al crear la cuenta'
            } finally {
                this.loading = false
            }
        }
    },
    watch: {
        showModal(val) {
            if (!val) {
                this.limpiarFormulario()
                this.errorMessage = ''
            }
        }
    }
}
</script>

<style src="../main.css"></style>